import { isReactivePromise } from './async.js';
import { getCurrentConsumer, setCurrentConsumer } from './consumer.js';
import { getInternalCurrentScope, setCurrentScope } from './contexts.js';
import { isPromise } from './utils/type-utils.js';
export function generatorResultToPromiseWithConsumer(generator, savedConsumer) {
    function adopt(value) {
        return typeof value === 'object' && value !== null && (isPromise(value) || isReactivePromise(value))
            ? value
            : Promise.resolve(value);
    }
    return new Promise((resolve, reject) => {
        function step(fn, value) {
            const prevConsumer = getCurrentConsumer();
            try {
                setCurrentConsumer(savedConsumer);
                const result = fn(value);
                if (result.done) {
                    resolve(result.value);
                }
                else {
                    adopt(result.value).then(fulfilled, rejected);
                }
            }
            catch (e) {
                reject(e);
            }
            finally {
                setCurrentConsumer(prevConsumer);
            }
        }
        const nextFn = generator.next.bind(generator);
        const throwFn = generator.throw.bind(generator);
        function fulfilled(value) {
            step(nextFn, value);
        }
        function rejected(value) {
            step(throwFn, value);
        }
        step(nextFn);
    });
}
export function generatorResultToPromiseWithScope(generator, savedScope) {
    function adopt(value) {
        return typeof value === 'object' && value !== null && (isPromise(value) || isReactivePromise(value))
            ? value
            : Promise.resolve(value);
    }
    return new Promise((resolve, reject) => {
        function step(fn, value) {
            const prevScope = getInternalCurrentScope();
            try {
                setCurrentScope(savedScope);
                const result = fn(value);
                if (result.done) {
                    resolve(result.value);
                }
                else {
                    adopt(result.value).then(fulfilled, rejected);
                }
            }
            catch (e) {
                reject(e);
            }
            finally {
                setCurrentScope(prevScope);
            }
        }
        const nextFn = generator.next.bind(generator);
        const throwFn = generator.throw.bind(generator);
        function fulfilled(value) {
            step(nextFn, value);
        }
        function rejected(value) {
            step(throwFn, value);
        }
        step(nextFn);
    });
}
